import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent {

    @Input() color: string = '';
    @Input() name: string = '';
    @Input() formControlData: FormControl<string> | undefined = undefined ;
    @Input() disabled: boolean = false ;
    @Output() changeColor: EventEmitter<string> = new EventEmitter<string>();

    change(event: string): void {
        this.changeColor.emit(event);
        event? this.formControlData?.patchValue(event) : null
    }
}
